import hostConfig from '@/config/host'
import hostConfigClient from '@/config/hostFromOrigin'
import http from '../lib/axios'
// const isProd = process.env.APP_ENV === 'production'

const baseParams = {
  version: '1.0',
  sourcetype: 0,
  timeZoneOffset: -480
}

// 邮箱注册
export const register = async (data) =>
  http.post(`${hostConfigClient()?.user}/user-api/v1/register-api-by-email`, {
    ...baseParams,
    ...data,
    source: 0
  })

// 获取价格列表
export const getApiPriceList = async (country) =>
  fetch(`${hostConfig.pay}/payapi/call`, {
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'cf-ipcountry': country || 'CN'
    },
    body: JSON.stringify({
      method: 'GetApiGoods',
      param: { currency: 1 },
      version: '1.2'
    })
  })

// 判断邮箱是否哈法
export const isEmailRegistered = async (data) =>
  http.post(`${hostConfigClient()?.user}/user-api/v1/verify-email`, {
    ...data,
    app: 'API'
  })

/**
 *
 * 获取用户协议版本
 */
export const getPrivacyVersion = async () => http.post(`${hostConfigClient()?.user}/user-api/v1/get-privacy-agreement`)
